import { render, staticRenderFns } from "./matCateryMultiLeftTreeRightTable.vue?vue&type=template&id=a66497de&scoped=true&"
import script from "./matCateryMultiLeftTreeRightTable.vue?vue&type=script&lang=js&"
export * from "./matCateryMultiLeftTreeRightTable.vue?vue&type=script&lang=js&"
import style0 from "./matCateryMultiLeftTreeRightTable.vue?vue&type=style&index=0&id=a66497de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66497de",
  null
  
)

export default component.exports